export default function AboutSection() {
  return (
    <section className="relative flex items-center justify-center min-h-screen px-6 py-24 overflow-hidden">
      {/* Gold separator line */}
      <div
        className="absolute bottom-4 left-0 right-0 h-px"
        style={{
          background:
            'linear-gradient(to right, transparent, hsl(var(--accent-gold) / 0.3), transparent)',
        }}
      />

      <div className="relative z-10 flex flex-col gap-6 max-w-3xl w-full text-center">
        <div className="text-2xl sm:text-3xl lg:text-4xl font-character text-foreground/70 leading-relaxed space-y-6">
          <p>
            Polymyth is a role-playing games platform that empowers players to adventure from
            anywhere and on any device.
          </p>
          <p>
            Compatible with fifth edition, Polymyth simplifies and automates the technical side of
            role-playing, making it accessible and enjoyable for everyone.
          </p>
        </div>
      </div>
    </section>
  );
}
